export default "__VITE_ASSET__b2907a69__"